
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("leLdu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $5wHqn = parcelRequire("5wHqn");


var $lpNn5 = parcelRequire("lpNn5");


var $7ZB0A = parcelRequire("7ZB0A");


var $6B1vK = parcelRequire("6B1vK");


var $jECFp = parcelRequire("jECFp");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");

function $b938a752f9cdcabf$export$fd5a90cff4ec1050(list) {
    return list[Math.floor(Math.random() * list.length)];
}
var $b938a752f9cdcabf$export$b3eb21c9d2ded28b = /*#__PURE__*/ function(EmojiPageHeaderCohort) {
    EmojiPageHeaderCohort["NOT_ENROLLED"] = "not-enrolled";
    EmojiPageHeaderCohort["CONTROL"] = "control";
    EmojiPageHeaderCohort["EMOJI"] = "emoji";
    EmojiPageHeaderCohort["HEADER"] = "header";
    EmojiPageHeaderCohort["EMOJI_AND_HEADER"] = "emoji_and_header";
    return EmojiPageHeaderCohort;
}({});

const $39022daf6a4c1688$export$4e7972dcd38f7091 = [
    {
        emoji_value: '1f91d',
        emoji_title: 'Handshake'
    },
    {
        emoji_value: '1f9e0',
        emoji_title: 'Brain'
    },
    {
        emoji_value: '1f680',
        emoji_title: 'Rocket'
    },
    {
        emoji_value: '1fa84',
        emoji_title: 'Magic Wang'
    },
    {
        emoji_value: '1f4a1',
        emoji_title: 'Bulb'
    },
    {
        emoji_value: '1f9e9',
        emoji_title: 'Jigsaw'
    },
    {
        emoji_value: '2728',
        emoji_title: 'Sparkles'
    },
    {
        emoji_value: '1f4ad',
        emoji_title: 'Thought Balloon'
    },
    {
        emoji_value: '1f64c',
        emoji_title: 'Raising Hands'
    },
    {
        emoji_value: '1f4bb',
        emoji_title: 'Computer'
    }
];
const $39022daf6a4c1688$export$d787f12e5de18134 = [
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1554034483-04fda0d3507b?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/GLf7bAwCdYg/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_1'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1557683316-973673baf926?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/pJadQetzTkI/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_2'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1618397746666-63405ce5d015?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/iFu2HILEng8/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_3'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/pxoZSTdAzeU/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_4'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1533090161767-e6ffed986c88?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/BlIhVfXbi9s/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_5'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1503551723145-6c040742065b-v2?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/ETRPjvb0KM0/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_6'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1518655048521-f130df041f66?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/VieM9BdZKFo/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_7'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1577017040065-650ee4d43339?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/xREzOtWzDrQ/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_8'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1508841220-87fbee1b4767?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/4umhCRrivis/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_9'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1751315039431-86ad38f1b046?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/FsZoT5CQjm0/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_10'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1750190437388-862aeca97f9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/Ljkx9b71l54/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_11'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/Q1p7bh3SHj8/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_12'
    },
    {
        header_image: '{"id":"https://images.unsplash.com/photo-1479030160180-b1860951d696?crop=entropy&cs=srgb&fm=jpg&ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA&ixlib=rb-4.1.0&q=85","position":50}',
        download_link: 'https://api.unsplash.com/photos/WeYamle9fDM/download?ixid=M3wyMDQ0MDF8MHwxfHNlYXJjaHw1fHxjb2xvcnxlbnwwfDB8fHwxNzUwMTY1NjE0fDA',
        header_name: 'header_image_13'
    }
];



var $b3j2Y = parcelRequire("b3j2Y");


var $7PLO8 = parcelRequire("7PLO8");


var $3jwuS = parcelRequire("3jwuS");


var $jlIaF = parcelRequire("jlIaF");


var $99t4P = parcelRequire("99t4P");


var $LSims = parcelRequire("LSims");



var $e4o8D = parcelRequire("e4o8D");


var $jmjWc = parcelRequire("jmjWc");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $5kqgA = parcelRequire("5kqgA");


var $1dhEU = parcelRequire("1dhEU");


var $crLHf = parcelRequire("crLHf");


var $3shHM = parcelRequire("3shHM");


var $brn6e = parcelRequire("brn6e");


var $AV9gd = parcelRequire("AV9gd");


var $8rneB = parcelRequire("8rneB");


var $Qlykt = parcelRequire("Qlykt");


var $5amrO = parcelRequire("5amrO");


var $ktUCG = parcelRequire("ktUCG");




/**
 * @generated SignedSource<<30a83cb048c6998ac25f1b7cb92a51f4>>
 * @relayHash 7afcbc16176f32c351c7b4d37a8db3cb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e19a480b4a1bad799e460756eb2ff7e6ca8390a94f5ad42533c615a9367035f
const $83c2e41cefa23c81$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceIconSpaceIconQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceIconSpaceIconQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7afcbc16176f32c351c7b4d37a8db3cb",
            "id": "5e19a480b4a1bad799e460756eb2ff7e6ca8390a94f5ad42533c615a9367035f",
            "metadata": {},
            "name": "useSpaceIconSpaceIconQuery",
            "operationKind": "query",
            "text": "query useSpaceIconSpaceIconQuery($spaceKey:String!){space(key:$spaceKey){id,icon{path},homepage{id}}}"
        }
    };
}();
$83c2e41cefa23c81$var$node.hash = "3d2bab97a5f5ad529c57f87fecaeb1f2";
var $83c2e41cefa23c81$export$2e2bcd8739ae039 = $83c2e41cefa23c81$var$node;



var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");




const $b00dc175a1d9f562$export$451b1c9c9e3f3651 = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { emojiLoading: emojiLoading, hasSelectedEmoji: hasSelectedEmoji, contentId: contentId } = t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== emojiLoading || $[1] !== hasSelectedEmoji || $[2] !== spaceKey) {
        t1 = !emojiLoading && !hasSelectedEmoji && Boolean(spaceKey) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        $[0] = emojiLoading;
        $[1] = hasSelectedEmoji;
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const shouldQueryForSpaceIcon = t1;
    const t2 = spaceKey || "";
    let t3;
    if ($[4] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = !shouldQueryForSpaceIcon;
    let t5;
    if ($[6] !== t3 || $[7] !== t4) {
        t5 = {
            variables: t3,
            skip: t4
        };
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $83c2e41cefa23c81$export$2e2bcd8739ae039), {
        ...t5,
        __callerPackage__: "emoji-title"
    });
    const isEditingOverview = data?.space?.homepage?.id === contentId;
    const t6 = isEditingOverview ? data?.space?.icon?.path : undefined;
    let t7;
    if ($[9] !== loading || $[10] !== t6) {
        t7 = {
            spaceIconPath: t6,
            loading: loading
        };
        $[9] = loading;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
};



var $5DJsZ = parcelRequire("5DJsZ");

/**
 * @generated SignedSource<<799c6acfe275aa35029653bbf8f0eac6>>
 * @relayHash 2ba82ef3194d6435da85787eb8d718e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa4b82a5dd981a817de03e11fcb3d41fcffdc099a4975909d8fbe2c38c20d335
const $086ed18565cd8445$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "value"
    }, v5 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "ConfluencePageProperty",
                                    "kind": "LinkedField",
                                    "name": "pageProperty",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceCreatePagePropertyPayload",
                            "kind": "LinkedField",
                            "name": "createPageProperty",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "ConfluencePageProperty",
                                    "kind": "LinkedField",
                                    "name": "pageProperty",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "2ba82ef3194d6435da85787eb8d718e5",
            "id": "fa4b82a5dd981a817de03e11fcb3d41fcffdc099a4975909d8fbe2c38c20d335",
            "metadata": {},
            "name": "useEmojiEverSetPropertyMutation",
            "operationKind": "mutation",
            "text": "mutation useEmojiEverSetPropertyMutation($input:ConfluenceCreatePagePropertyInput!){confluence{createPageProperty(input:$input){success,pageProperty{key,value,id},errors{message}}}}"
        }
    };
}();
$086ed18565cd8445$var$node.hash = "771265924e6d3ef23e44e1c16875a2ba";
var $086ed18565cd8445$export$2e2bcd8739ae039 = $086ed18565cd8445$var$node;



var $32Xjk = parcelRequire("32Xjk");





var $308Wd = parcelRequire("308Wd");






const $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY = 'emoji-ever-set';
function $21d4c90e14666aa3$export$c30a2ad7de291c21({ pageAri: pageAri, contentId: contentId, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, isLivePage: isLivePage, autoPageEmojiCohort: autoPageEmojiCohort }) {
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $32Xjk.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "emoji-title"
    });
    const [createPropertyMutation, { loading: updating }] = (0, $308Wd.useMutationInterop)(/** @schema agg */ (0, $086ed18565cd8445$export$2e2bcd8739ae039), {
        context: {
            headers: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            }
        },
        __callerPackage__: "emoji-title"
    });
    const setEmojiEverSet = (0, $cozmU.useCallback)(async (value = true)=>{
        if (!contentId || !pageAri) return false;
        try {
            const result = await createPropertyMutation({
                variables: {
                    input: {
                        pageId: pageAri,
                        key: $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY,
                        value: String(value)
                    }
                }
            });
            const success = result?.data?.confluence?.createPageProperty?.success;
            if (success) {
                refetch();
                if (createAnalyticsEvent && autoPageEmojiCohort && autoPageEmojiCohort === 'random') createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'success',
                        actionSubject: 'updateEmojiEverSetProperty',
                        source: 'useEmojiEverSetProperty',
                        attributes: {
                            cohort: autoPageEmojiCohort,
                            contentType: contentType,
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return success || false;
        } catch  {
            if (createAnalyticsEvent && autoPageEmojiCohort && autoPageEmojiCohort === 'random') createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'errored',
                    actionSubject: 'updateEmojiEverSetProperty',
                    source: 'useEmojiEverSetProperty',
                    attributes: {
                        cohort: autoPageEmojiCohort,
                        contentType: contentType,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
            return false;
        }
    }, [
        contentId,
        pageAri,
        createPropertyMutation,
        refetch,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data && createAnalyticsEvent && autoPageEmojiCohort && autoPageEmojiCohort === 'random') createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'success',
                actionSubject: 'emojiEverSetProperty',
                source: 'useEmojiEverSetProperty',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        data,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (error && createAnalyticsEvent && autoPageEmojiCohort && autoPageEmojiCohort === 'random') createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'emojiEverSetProperty',
                source: 'useEmojiEverSetProperty',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent,
        contentType,
        isLivePage,
        autoPageEmojiCohort
    ]);
    if (!contentId || !pageAri) // By default, we don't want to set the emoji if we don't know the result so hasEverSetEmoji is true.
    return {
        hasEverSetEmoji: true,
        setEmojiEverSet: ()=>Promise.resolve(false),
        loading: false,
        error: null,
        updating: false
    };
    const currentValue = data?.content?.nodes?.[0]?.properties?.nodes?.find((prop)=>prop?.key === $21d4c90e14666aa3$var$EMOJI_EVER_SET_PROPERTY_KEY)?.value;
    const hasEverSetEmoji = currentValue === 'true';
    return {
        hasEverSetEmoji: hasEverSetEmoji,
        setEmojiEverSet: setEmojiEverSet,
        loading: loading,
        error: error,
        updating: updating
    };
}



const $f5191b0954c119ca$var$LiveDocsDefaultIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d9Ygm",
    name: "LiveDocsDefaultIcon",
    loader: async ()=>(await (parcelRequire("lA1e7"))).LiveDocsDefaultIcon,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: props.size
        })
});
const $f5191b0954c119ca$export$c6f7e57f9a3b1251 = 20;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$EmojiButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1e0c1txw" : "_1e0c18uv",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_ae4v1h6o" : "_ae4v4jg8",
            __cmplp.isTitleCenterAligned && !__cmplp.hasCoverPicture ? "_4cvr1h6o" : "_4cvr4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$EmojiIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _ca0qn7od _u5f3n7od _n3tdn7od _19bvn7od _1e0c1txw _1bah1h6o _19pkn7od",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_p12fgktf" : __cmplp.hasCoverPicture ? "_p12fys9h" : "_p12f1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f5191b0954c119ca$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            __cmplp.isTitleCenterAligned ? "_u5f3idpf" : "_u5f3u2gc",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_18u0i2wt" : "_18u0ze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f5191b0954c119ca$export$33fbbc033604b878 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, shouldHide: shouldHide, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkn7od",
            __cmplp.isTitleCenterAligned ? "_2hwxidpf" : "_2hwxutpp",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_19bvidpf" : "_19bv1b66",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_p12fgktf" : __cmplp.hasCoverPicture ? "_p12fys9h" : "_p12f1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.shouldHide ? "_1e0cglyw" : !__cmplp.hasCoverPicture && !__cmplp.isTitleCenterAligned ? "_1e0c1txw" : "_1e0c1kw7",
            __cmplp.shouldHide ? "_y05fidpf" : "_y05fkb7n",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$EmojiIconOuterWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        const { isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1tkegktf" : __cmplp.hasCoverPicture ? "_1tkeys9h" : "_1tke1ylp",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_1ul9gktf" : __cmplp.hasCoverPicture ? "_1ul9ys9h" : "_1ul91ylp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5191b0954c119ca$var$SpaceIconImg = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1mok _1wpz1h6o _1pbyidpf",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_19pkze3t" : "_19pk1b66",
            __cmplp.isTitleCenterAligned ? "_2hwxze3t" : "_2hwxu2gc",
            __cmplp.isTitleCenterAligned ? "_otyrpxbi" : "_otyrze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // During SSR inline styles have problems getting calculated so needs to be moved into a styled button component
const $f5191b0954c119ca$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $7ZB0A.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_w1ap1tcg" : __cmplp.hasCoverPicture ? "_w1apys9h" : "_w1ap1wug",
            __cmplp.isWhiteboardEmojiFGEnabled ? "_btpd1tcg" : __cmplp.hasCoverPicture ? "_btpdys9h" : "_btpd1wug",
            __cmplp.isReadOnly ? "_1mr21wug" : "_1mr2tlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5191b0954c119ca$var$PopupComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    let otherProps;
    let style;
    if ($[0] !== props) {
        ({ style: style, ...otherProps } = props);
        $[0] = props;
        $[1] = otherProps;
        $[2] = style;
    } else {
        otherProps = $[1];
        style = $[2];
    }
    let t0;
    if ($[3] !== style) {
        t0 = {
            ...style
        };
        $[3] = style;
        $[4] = t0;
    } else t0 = $[4];
    let t1;
    if ($[5] !== otherProps || $[6] !== ref || $[7] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...otherProps,
            ref: ref,
            style: t0
        });
        $[5] = otherProps;
        $[6] = ref;
        $[7] = t0;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
});
const $f5191b0954c119ca$var$i18n = (0, $kSwu1.defineMessages)({
    changeEmoji: {
        id: "emoji-title.change-emoji",
        defaultMessage: "Change emoji"
    },
    spaceIconAlt: {
        id: "emoji-title.space-icon-alt",
        defaultMessage: "space icon"
    },
    liveDocsDefaultIconLabel: {
        id: "emoji-title.live-docs-default-icon-label",
        defaultMessage: "Live doc emoji"
    }
}); // Returns previous emoji ID
function $f5191b0954c119ca$var$usePrevious(value) {
    const emojiRef = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        emojiRef.current = value;
    }, [
        value
    ]);
    return emojiRef.current;
}
const $f5191b0954c119ca$var$EmojiTitleSelectionComponent = ({ contentId: contentId, onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, isTitleDisabled: isTitleDisabled, linkCreation: linkCreation, emojiTitleState: emojiTitleState, isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, isReadOnly: isReadOnly, contentType: contentType, updateContentTree: updateContentTree, hasInitialEmoji: hasInitialEmoji, pageTitleContent: pageTitleContent, autoPageEmojiCohort: autoPageEmojiCohort, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, emojiTitleDiscovered: emojiTitleDiscovered, isSmartCreate: isSmartCreate })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [{ aiSuggestedEmojiId: aiSuggestedEmojiId, aiEmojiSuggestionSource: aiEmojiSuggestionSource, aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId, hasPasteAutoTitleEmojiAppliedThisSession: hasPasteAutoTitleEmojiAppliedThisSession }, { setHasPasteAutoTitleEmojiAppliedThisSession: setHasPasteAutoTitleEmojiAppliedThisSession }] = (0, $jECFp.useAIEmojiSuggestion)();
    const onPasteAutoTitleEmojiApplied = (0, $cozmU.useCallback)(()=>setHasPasteAutoTitleEmojiAppliedThisSession(true), [
        setHasPasteAutoTitleEmojiAppliedThisSession
    ]);
    const intl = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const emojiStatusFieldName = (0, $5amrO.useEmojiStatusFieldName)(contentType);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const pageAri = (0, $cozmU.useMemo)(()=>{
        try {
            return (0, $6B1vK.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            }).toString();
        } catch  {
            return null;
        }
    }, [
        cloudId,
        contentId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { hasEverSetEmoji: hasEverSetEmoji, setEmojiEverSet: setEmojiEverSet, loading: emojiEverSetPropertyLoading, error: emojiEverSetPropertyError, updating: emojiEverSetPropertyUpdating } = (0, $21d4c90e14666aa3$export$c30a2ad7de291c21)({
        pageAri: pageAri,
        contentId: contentId,
        createAnalyticsEvent: createAnalyticsEvent,
        contentType: contentType,
        isLivePage: isLivePage,
        autoPageEmojiCohort: autoPageEmojiCohort
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const hasGeneratedEmojiBefore = hasEverSetEmoji || emojiEverSetPropertyError || emojiEverSetPropertyLoading || emojiEverSetPropertyUpdating;
    const isWhiteboardEmojiFGEnabled = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    const closeBothEmojiPicker = ()=>{
        emojiTitleState.setOpenFirstEmojiPicker(false);
        emojiTitleState.setOpenSecondEmojiPicker(false);
    };
    const hasReplacedAIFCEmojiRef = (0, $cozmU.useRef)(false); // optimistically show placeholder prior to querying for emoji data when
    // parent component has determined that there should be an emoji
    const [showOptimisticPlaceholder, setShowOptimisticPlaceholder] = (0, $cozmU.useState)(!!hasInitialEmoji); // Track current emoji data for versioning
    const currentEmojiDataRef = (0, $cozmU.useRef)(null);
    const isInRandomEmojiCohort = autoPageEmojiCohort && autoPageEmojiCohort === 'random'; // Additional checks to see if the user is eligible to get a random emoji on the content they are on.
    // These checks are: the content is a draft page, draft blogpost or live page, the editor is empty, and there is no title.
    const isEligibleForRandomEmojiExperience = isInRandomEmojiCohort && (isLivePage || isUnpublishedDraft) && isEditorEmpty && !pageTitleContent;
    const { updateContentProperty: updateContentProperty } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page',
        options: {
            refetchQueries: [
                {
                    query: (0, $5DJsZ.default),
                    variables: {
                        contentId: contentId,
                        status: [
                            'current',
                            'draft'
                        ],
                        skipPublishedFragment: false,
                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                    }
                }
            ]
        }
    }); // Helper function to convert emoji character to Unicode ID
    const emojiToUnicode = (emoji)=>{
        const codePoint = emoji.codePointAt(0);
        return codePoint?.toString(16) || '';
    };
    const handleAutoEmojiSelection = (0, $cozmU.useCallback)(async (autoEmojiId)=>{
        if (autoEmojiId) {
            // converts emoji character to unicode id
            const isEmojiCharacter = !/^[0-9a-f]+$/i.test(autoEmojiId);
            const unicodeId = isEmojiCharacter ? emojiToUnicode(autoEmojiId) : autoEmojiId; // load full emoji data for UI display
            if (!userId) return;
            const loadedEmoji = await (0, $brn6e.getEmojiFromEmojiId)({
                userId: userId,
                cloudId: cloudId,
                emojiId: unicodeId
            });
            if (loadedEmoji) {
                emojiTitleState.setSelectedEmoji(loadedEmoji); // save to backend
                const propertyKey = emojiStatusFieldName === 'emojiTitlePublished' ? 'emoji-title-published' : 'emoji-title-draft';
                const emojiValue = unicodeId.replace(/['"]+/g, ''); // get current version number from previous emoji data and increment it
                const currentVersion = currentEmojiDataRef.current && (0, $8rneB.getVersionNumber)(currentEmojiDataRef.current, emojiStatusFieldName);
                updateContentProperty({
                    propertyKey: propertyKey,
                    propertyValue: emojiValue,
                    hasExistingProperty: currentVersion > 0
                });
                setEmojiEverSet(true);
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        emojiTitleState,
        cloudId,
        userId,
        updateContentProperty,
        contentId,
        emojiStatusFieldName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!emojiTitleDiscovered && !hasGeneratedEmojiBefore && !emojiTitleState.state.selectedEmoji && isEligibleForRandomEmojiExperience) {
            const randomEmojiId = (0, $b938a752f9cdcabf$export$fd5a90cff4ec1050)((0, $39022daf6a4c1688$export$4e7972dcd38f7091)).emoji_value;
            handleAutoEmojiSelection(randomEmojiId);
        }
    }, [
        emojiTitleDiscovered,
        hasGeneratedEmojiBefore,
        emojiTitleState.state.selectedEmoji,
        isEligibleForRandomEmojiExperience,
        handleAutoEmojiSelection
    ]);
    const isPasteAutoTitleSurface = aiEmojiSuggestionSource === 'pasteAutoTitle';
    const isSuggestTitleSurface = aiEmojiSuggestionSource === 'suggestTitle'; // Both of the surfaces share the same "applied this session" gating + reset mechanics.
    const isAITitleGenSurface = isPasteAutoTitleSurface || isSuggestTitleSurface;
    (0, $cozmU.useEffect)(()=>{
        if (aiEmojiSuggestionSessionId !== undefined) hasReplacedAIFCEmojiRef.current = false;
    }, [
        aiEmojiSuggestionSessionId
    ]); // Apply the AI-suggested emoji. Guards (in order):
    // 1. !selectedEmoji — never overwrite a user-set emoji.
    // 2. AIFC: hasGeneratedEmojiBefore (BE-persisted, survives remove).
    // 3. paste-title: hasPasteAutoTitleEmojiAppliedThisSession (parent state, survives remounts).
    (0, $cozmU.useEffect)(()=>{
        if (!aiSuggestedEmojiId || emojiTitleState.state.selectedEmoji) return;
        if (!isAITitleGenSurface && hasGeneratedEmojiBefore) return;
        if (isAITitleGenSurface && hasPasteAutoTitleEmojiAppliedThisSession) return;
        handleAutoEmojiSelection(aiSuggestedEmojiId);
        if (isAITitleGenSurface) {
            onPasteAutoTitleEmojiApplied?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'set',
                    actionSubject: 'pageEmoji',
                    actionSubjectId: isSuggestTitleSurface ? 'suggestTitleSuggestionLanded' : 'blankPageAutoPasteSuggestionLanded',
                    source: 'EmojiTitleSelection',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        cohort: autoPageEmojiCohort,
                        aiSuggestedEmojiId: aiSuggestedEmojiId,
                        aiEmojiSuggestionSource: aiEmojiSuggestionSource,
                        aiEmojiSuggestionSessionId: aiEmojiSuggestionSessionId
                    }
                }
            }).fire();
        }
    }, [
        aiSuggestedEmojiId,
        hasGeneratedEmojiBefore,
        emojiTitleState.state.selectedEmoji,
        handleAutoEmojiSelection,
        isAITitleGenSurface,
        isSuggestTitleSurface,
        hasPasteAutoTitleEmojiAppliedThisSession,
        onPasteAutoTitleEmojiApplied,
        aiEmojiSuggestionSource,
        aiEmojiSuggestionSessionId,
        createAnalyticsEvent,
        contentId,
        contentType,
        autoPageEmojiCohort
    ]);
    (0, $cozmU.useEffect)(()=>{
        //analytics event for auto emoji exp cohort assignment
        if (autoPageEmojiCohort && (autoPageEmojiCohort === 'random' || autoPageEmojiCohort === 'control')) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'assigned',
                actionSubject: 'autoEmojiExperiment',
                source: 'EmojiTitleSelection',
                attributes: {
                    cohort: autoPageEmojiCohort,
                    contentType: contentType,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        autoPageEmojiCohort,
        contentType,
        isLivePage,
        createAnalyticsEvent
    ]);
    const isUndefinedLink = isTitleDisabled && linkCreation;
    const shouldQueryEmoji = !isTitleDisabled || isUndefinedLink;
    const { data: data, error: error, refetch: refetchEmoji, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $5DJsZ.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        fetchPolicy: 'cache-and-network',
        skip: !shouldQueryEmoji,
        __callerPackage__: "emoji-title"
    });
    const emojiId = (data && (0, $8rneB.getEmojiId)(data, emojiStatusFieldName)) ?? ''; // Update ref when data changes
    (0, $cozmU.useEffect)(()=>{
        currentEmojiDataRef.current = data;
    }, [
        data
    ]);
    const updateLivePagesDefaultIcon = (0, $cozmU.useCallback)(()=>{
        if (isLivePage && data) {
            const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(data);
            emojiTitleState.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji);
        }
    }, [
        data,
        isLivePage,
        emojiTitleState
    ]); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const hasEmoji = !!emojiTitleState.state.selectedEmoji;
    (0, $cozmU.useEffect)(()=>{
        if (hasEmoji && emojiId.length > 0) (0, $brn6e.getEmojiFromEmojiId)({
            userId: userId,
            cloudId: cloudId,
            emojiId: emojiId
        }).then((emoji)=>{
            if (emoji) emojiTitleState.setSelectedEmoji(emoji);
            emojiTitleState.setLoadingEmoji(false);
        });
        else if (!loading && emojiTitleState.state.isLoading) emojiTitleState.setLoadingEmoji(false);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasEmoji,
        emojiId,
        loading
    ]); // Previous Emoji ID
    const previousEmojiId = $f5191b0954c119ca$var$usePrevious(emojiId);
    const onEmojiIdChange = previousEmojiId != emojiId; // Used to update the content tree emoji when the emoji is changed from the header
    if (onEmojiIdChange && updateContentTree) updateContentTree();
    const { spaceIconPath: spaceIconPath } = (0, $b00dc175a1d9f562$export$451b1c9c9e3f3651)({
        emojiLoading: loading,
        hasSelectedEmoji: Boolean(emojiTitleState.state.selectedEmoji),
        contentId: contentId
    }); // Live docs default icon and optimistic placeholder
    (0, $cozmU.useEffect)(()=>{
        const setEmojiStateAndUpdateOptimisticPlaceholder = async ()=>{
            // When default emoji is enabled, we need to wait until after the emojiTitleState is set
            // to stop rendering the optimistic placeholder in order to prevent flashing
            updateLivePagesDefaultIcon();
            if (data) setShowOptimisticPlaceholder(false);
        };
        setEmojiStateAndUpdateOptimisticPlaceholder();
    }, [
        data,
        updateLivePagesDefaultIcon
    ]); // clean up emojiTitleState on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            emojiTitleState.setSelectedEmoji(null);
            emojiTitleState.setHasLiveDocsDefaultEmoji(false);
        };
    }, [
        emojiTitleState
    ]);
    const getEmojiSize = ()=>isWhiteboardEmojiFGEnabled ? $f5191b0954c119ca$export$c6f7e57f9a3b1251 : hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM); // Use state container since it has the most up to date info
    const shouldRenderEmoji = Boolean(hasEmoji && !emojiTitleState.state.isUpdatingEmoji && emojiTitleState.state.selectedEmoji);
    const hasDefaultLiveEmoji = emojiTitleState.state.hasLiveDocsDefaultEmoji && !emojiTitleState.state.isRemovingEmoji && !emojiTitleState.state.isUpdatingEmoji;
    const shouldRenderDefaultLiveEmoji = hasDefaultLiveEmoji && !hasEmoji;
    const shouldHidePlaceholder = !hasEmoji && !hasDefaultLiveEmoji && !showOptimisticPlaceholder;
    if (renderServerPlaceholder && !spaceIconPath) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$export$33fbbc033604b878, {
        "data-testid": "emoji-placeholder",
        shouldHide: shouldHidePlaceholder,
        "aria-hidden": shouldHidePlaceholder,
        hasCoverPicture: hasCoverPicture,
        isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled,
        isTitleCenterAligned: isTitleCenterAligned
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
        height: getEmojiSize(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "emoji-placeholder"
    }));
    if (shouldRenderEmoji || shouldRenderDefaultLiveEmoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$export$e31a6cc0a4c97f0e, {
        "data-testid": isTitleCenterAligned ? 'emoji-wrapper-centered' : 'emoji-wrapper',
        isTitleCenterAligned: isTitleCenterAligned,
        isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        autoFocus: false,
        isOpen: emojiTitleState.state.openFirstEmojiPicker,
        onClose: ()=>{},
        popupComponent: $f5191b0954c119ca$var$PopupComponent,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $AV9gd.EmojiPickerLoader), {
                contentId: contentId,
                onUpdateStartEmoji: onUpdateStartEmoji,
                emojiTitleState: emojiTitleState,
                onEmojiUpdated: refetchEmoji,
                onUpdateEndEmoji: onUpdateEndEmoji,
                updateContentProperty: updateContentProperty,
                closeBothEmojiPicker: closeBothEmojiPicker,
                componentName: "EmojiTitleSelection",
                contentType: contentType,
                isSmartCreate: isSmartCreate,
                hasReplacedAIFCEmojiRef: hasReplacedAIFCEmojiRef
            }),
        placement: "bottom-start",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$EmojiButtonWrapper, {
                isTitleCenterAligned: isTitleCenterAligned,
                hasCoverPicture: hasCoverPicture,
                isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$StyledButton, {
                ...triggerProps,
                appearance: "subtle",
                testId: "emoji-button",
                shouldFitContainer: true,
                hasCoverPicture: hasCoverPicture,
                isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled,
                isReadOnly: isReadOnly,
                isDisabled: isReadOnly || isUndefinedLink,
                onClick: ()=>{
                    emojiTitleState.setOpenFirstEmojiPicker(!emojiTitleState.state.openFirstEmojiPicker);
                    emojiTitleState.setOpenSecondEmojiPicker(false);
                    if (isInRandomEmojiCohort && !emojiTitleDiscovered) {
                        setOnboardingState({
                            key: (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED,
                            value: 'true'
                        });
                        createAnalyticsEvent({
                            type: 'sendTrackEvent',
                            data: {
                                action: 'completed',
                                actionSubject: 'emojiTitleDiscoveredOnboarding',
                                source: 'EmojiTitleSelection',
                                attributes: {
                                    cohort: 'random',
                                    contentType: contentType,
                                    isLivePage: isLivePage
                                }
                            }
                        }).fire();
                    }
                    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
                        eventType: 'sendUIEvent',
                        element: 'button',
                        action: 'clicked',
                        actionSubject: 'editEmojiButton',
                        actionSubjectId: 'emojiIcon',
                        attributes: {
                            cohort: autoPageEmojiCohort,
                            contentType: contentType,
                            isLivePage: isLivePage
                        }
                    });
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$EmojiIconOuterWrapper // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                , {
                    className: "emoji-icon",
                    "data-testid": "emoji-icon",
                    hasCoverPicture: !!hasCoverPicture,
                    isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: intl.formatMessage($f5191b0954c119ca$var$i18n.changeEmoji),
                    position: hasCoverPicture ? 'top' : 'left'
                }, shouldRenderDefaultLiveEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$LiveDocsDefaultIcon, {
                    label: intl.formatMessage($f5191b0954c119ca$var$i18n.liveDocsDefaultIconLabel),
                    size: getEmojiSize(),
                    testId: "live-docs-default-title-icon",
                    isMarkdownMode: isMarkdownMode
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$EmojiIconWrapper, {
                    hasCoverPicture: !!hasCoverPicture,
                    isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1dhEU.EmojiComponent), {
                    emoji: emojiTitleState.state.selectedEmoji,
                    height: getEmojiSize(),
                    context: "editor",
                    renderResourcedEmoji: true,
                    hasCoverPicture: hasCoverPicture,
                    isPageTitleComponent: true
                }))))
            }))
    }));
    else if (!isWhiteboardEmojiFGEnabled) {
        if (spaceIconPath && !emojiId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$SpaceIconImg, {
            src: `${(0, $jlIaF.CONTEXT_PATH)}${spaceIconPath}`,
            height: getEmojiSize(),
            width: getEmojiSize(),
            isTitleCenterAligned: isTitleCenterAligned,
            hasCoverPicture: hasCoverPicture,
            alt: intl.formatMessage($f5191b0954c119ca$var$i18n.spaceIconAlt)
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$export$33fbbc033604b878, {
            "data-testid": "emoji-placeholder",
            shouldHide: shouldHidePlaceholder,
            "aria-hidden": shouldHidePlaceholder,
            hasCoverPicture: hasCoverPicture,
            isWhiteboardEmojiFGEnabled: isWhiteboardEmojiFGEnabled,
            isTitleCenterAligned: isTitleCenterAligned
        }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: getEmojiSize(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "emoji-placeholder"
        }));
    }
};
const $f5191b0954c119ca$export$2626335f65c6c2ab = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $ktUCG.EmojiTitleStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t0
        }, (emojiTitleState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5191b0954c119ca$var$EmojiTitleSelectionComponent, {
                "data-testid": "emoji-title-selection",
                ...props,
                emojiTitleState: emojiTitleState
            }));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
$f5191b0954c119ca$export$2626335f65c6c2ab.displayName = 'EmojiTitleSelection';
module.exports["EMOJI_SIZE_WHITEBOARD"] = $f5191b0954c119ca$export$c6f7e57f9a3b1251;
module.exports["EmojiWrapper"] = $f5191b0954c119ca$export$e31a6cc0a4c97f0e;
module.exports["EmojiPlaceholderWrapper"] = $f5191b0954c119ca$export$33fbbc033604b878;
module.exports["EmojiTitleSelection"] = $f5191b0954c119ca$export$2626335f65c6c2ab;

});

parcelRegister("6B1vK", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/page/manifest.ts
var $4cd75eda3ba03299$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $4cd75eda3ba03299$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $4cd75eda3ba03299$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("jECFp", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $a0bb26fc274d4fce$var$initialState = {
    aiSuggestedEmojiId: undefined,
    aifcSuggestionInFlight: false,
    aiEmojiSuggestionSource: undefined,
    aiEmojiSuggestionSessionId: 0,
    hasPasteAutoTitleEmojiAppliedThisSession: false
};
const $a0bb26fc274d4fce$var$actions = {
    setAISuggestedEmojiId: (aiSuggestedEmojiId)=>({ setState: setState })=>{
            setState({
                aiSuggestedEmojiId: aiSuggestedEmojiId
            });
        },
    setAifcSuggestionInFlight: (aifcSuggestionInFlight)=>({ setState: setState })=>{
            setState({
                aifcSuggestionInFlight: aifcSuggestionInFlight
            });
        },
    setAIEmojiSuggestionSource: (aiEmojiSuggestionSource)=>({ setState: setState })=>{
            setState({
                aiEmojiSuggestionSource: aiEmojiSuggestionSource
            });
        },
    setHasPasteAutoTitleEmojiAppliedThisSession: (hasPasteAutoTitleEmojiAppliedThisSession)=>({ setState: setState })=>{
            setState({
                hasPasteAutoTitleEmojiAppliedThisSession: hasPasteAutoTitleEmojiAppliedThisSession
            });
        },
    /**
   * Atomically bumps the session id and clears the companion fields. Called on
   * each new title-generating rising edge so each session starts clean. Always
   * prefer this over bumping `aiEmojiSuggestionSessionId` directly so the
   * session-reset contract cannot be broken.
   */ resetForNewSession: (nextSource)=>({ getState: getState, setState: setState })=>{
            setState({
                aiEmojiSuggestionSessionId: getState().aiEmojiSuggestionSessionId + 1,
                aiSuggestedEmojiId: undefined,
                aifcSuggestionInFlight: false,
                hasPasteAutoTitleEmojiAppliedThisSession: false,
                aiEmojiSuggestionSource: nextSource
            });
        }
};
const $a0bb26fc274d4fce$export$28f0982fc242dfc = (0, $8s9DV.createStore)({
    name: 'AIEmojiSuggestionStore',
    initialState: $a0bb26fc274d4fce$var$initialState,
    actions: $a0bb26fc274d4fce$var$actions
});
const $a0bb26fc274d4fce$export$ceaf53c089700a19 = (0, $kBr4q.createHook)($a0bb26fc274d4fce$export$28f0982fc242dfc);
const $a0bb26fc274d4fce$export$9ebb873254abc907 = (0, $kBr4q.createActionsHook)($a0bb26fc274d4fce$export$28f0982fc242dfc);
module.exports["useAIEmojiSuggestion"] = $a0bb26fc274d4fce$export$ceaf53c089700a19;
module.exports["useAIEmojiSuggestionActions"] = $a0bb26fc274d4fce$export$9ebb873254abc907;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("AV9gd", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cb0f340ec70ce939$export$ece7683bd8712e82 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "q1NFz",
    name: "EmojiPickerLoader",
    loader: async ()=>(await (parcelRequire("7Ckxq"))).EmojiPicker
});
module.exports["EmojiPickerLoader"] = $cb0f340ec70ce939$export$ece7683bd8712e82;

});

parcelRegister("7Ckxq", function(module, exports) {

let $58bc03715c6c892c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $58bc03715c6c892c$var$load("br7gN"),
    $58bc03715c6c892c$var$load("bNJC9"),
    $58bc03715c6c892c$var$load("hvMWl"),
    $58bc03715c6c892c$var$load("XgRtr")
]).then(()=>parcelRequire('aQXpZ'));

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Set to `true` once the Planner title-based agent suggestion banner has been
	 * dismissed (via the close button or by clicking the CTA) during the current
	 * browser session, so it is not re-shown again until the next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_PLANNER_DISMISSED_SESSION: 'confluence.title-agent-nudge.planner-dismissed-session',
    /**
	 * Set to `true` once the Discovery & Feedback title-based agent suggestion
	 * banner has been dismissed (via the close button or by clicking the CTA)
	 * during the current browser session, so it is not re-shown again until the
	 * next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_DISCOVERY_AND_FEEDBACK_DISMISSED_SESSION: 'confluence.title-agent-nudge.discovery-and-feedback-dismissed-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<1411d3b38bfd3828f39e9de902613b71>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("lA1e7", function(module, exports) {

let $fb5de958cc50b4e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb5de958cc50b4e1$var$load("hUvv7").then(()=>parcelRequire('daJSk'));

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("gsyiL", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/blogpost/manifest.ts
var $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $bfb9de7804f5bb44$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $bfb9de7804f5bb44$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});


//# sourceMappingURL=EmojiTitleSelection.5cead80b.js.map
